// ProductSlider.js
import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Container, SliderTitle } from "./BlogSlider.style";
import BlogCard from "./BlogCard";

const blogs = [
  {
    id: 1,
    name: "Blog Title 1",
    description: "Tónico reconstituyente para los estados de agotamiento nervioso",
    image: "https://eupha-ca.com/static/media/icon-blog.png",
    background: "https://eupha-ca.com/static/media/blog-1.png",
    link: "https://www.instagram.com/eupha.pharma/"
  },
  {
    id: 2,
    name: "Blog Title 2",
    description: "Tónico reconstituyente para los estados de agotamiento nervioso",
    image: "https://eupha-ca.com/static/media/icon-blog.png",
    background: "https://eupha-ca.com/static/media/blog-2.png",
    link: "https://www.instagram.com/eupha.pharma/"
  },
  {
    id: 3,
    name: "Blog Title 3",
    description: "Tónico reconstituyente para el agotamiento nervioso y psicofísico",
    image: "https://eupha-ca.com/static/media/icon-blog.png",
    background: "https://eupha-ca.com/static/media/blog-3.png",
    link: "https://www.instagram.com/eupha.pharma/"
  },
  {
    id: 4,
    name: "Blog Title 4",
    description: "Tónico reconstituyente para el agotamiento nervioso y psicofísico",
    image: "https://eupha-ca.com/static/media/icon-blog.png",
    background: "https://eupha-ca.com/static/media/blog-4.png",
    link: "https://www.instagram.com/eupha.pharma/"
  },
];

const ProductsSlider = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 400,
    slidesToShow: 4,
    slidesToScroll: 2,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  return (
    <Container>
      <Slider {...settings}>
        {blogs.map((blog) => (
          <BlogCard key={blog.id} blog={blog} />
        ))}
      </Slider>
    </Container>
  );
};

export default ProductsSlider;
